import React from 'react';
import {
  Card, Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import { Box } from '@mui/system';
import { OrderSummaryStyles } from './PlugStyles';
import profileIcon from '../Assets/member-icon.png';
import clockIcon from '../Assets/time-clock.svg';
import ReportSetsAccordion from './ReportSetsAccordion';
import VialAccordion from './VialAccordion';
import { capitalizeFirstLetters } from '../../../helpers/miscHelpers';

const OrderSummary = ({
  ordersData,
}) => {
  const [panel, setPanel] = React.useState('');
  return (
    <Box sx={OrderSummaryStyles.OrderSummaryContainer}>
      <Typography sx={OrderSummaryStyles.OrderSummaryTypo}>Order Summary</Typography>
      {!!ordersData?.length
      && ordersData.map((orderData) => (
        <Card sx={OrderSummaryStyles.MemberDetailsCard} key={orderData.id}>
          <Box sx={OrderSummaryStyles.CustomerHeader}>
            <img src={profileIcon} alt="profile" width={32} height={32} />
            <Box>
              <Box sx={OrderSummaryStyles.AccordionSummaryBox}>
                <Typography
                  sx={OrderSummaryStyles.Name}
                >
                  {capitalizeFirstLetters(String(orderData?.patient_name).toLowerCase())}
                </Typography>
              </Box>
              <Box sx={OrderSummaryStyles.AgeContainer}>
                <Typography
                  sx={OrderSummaryStyles.Age}
                >
                  {orderData?.age} Y
                </Typography>
                <Typography
                  sx={OrderSummaryStyles.Dot}
                >
                  •
                </Typography>
                <Typography
                  sx={OrderSummaryStyles.Gender}
                >
                  {capitalizeFirstLetters(String(orderData?.gender))}
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box sx={OrderSummaryStyles.DetailsContainer}>
            <Box sx={OrderSummaryStyles.ReportDetails}>
              <Box sx={OrderSummaryStyles.TimingHeader}>
                <img src={clockIcon} alt="profile" width={32} height={32} />
                <Typography
                  sx={OrderSummaryStyles.TimingHeaderText}
                >
                  Report timings
                </Typography>
              </Box>
              <Box sx={OrderSummaryStyles.ReportsContainer}>
                {orderData?.orders?.length > 0 && orderData?.orders?.map((order, index) => (
                  <Box sx={OrderSummaryStyles.ReportAccordionContainer} key={`${orderData.id}${order?.reportTat}`}>
                    <ReportSetsAccordion
                      panel={panel}
                      setPanel={setPanel}
                      order={order}
                      number={index + 1}
                      id={orderData.id}
                    />
                  </Box>
                ))}
              </Box>
            </Box>
            <Box sx={OrderSummaryStyles.VialsContainer}>
              {orderData?.vials?.length > 0
              && (
                <Box>
                  <VialAccordion
                    panel={panel}
                    setPanel={setPanel}
                    vials={orderData.vials}
                    id={orderData.id}
                  />
                </Box>
              )}
            </Box>
          </Box>
        </Card>
      ))}
      <Box sx={OrderSummaryStyles.ExtraSpace} />
    </Box>
  );
};

OrderSummary.propTypes = {
  ordersData: PropTypes.any,
};

export default OrderSummary;
